// tslint:disable
import * as React from 'react';

export class ListResponsePresenterWildcard extends React.Component<any, any> {

    render() {
        return (
            <div className="w-100">
                {(this.props.items.length && this.props.items.map((item: any, index: number) => this.props.row(item, index))) || <span></span>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/structurals/presenters/list-response-presenter-wildcard.tsx